// import Emitter from '../../emitter';
/**
 * @desc: 上传服务
 */
import driverManger from '../../driverManger';
export const codeProcessor = {
    id: 'code.processor',
    getDriver(name) {
        let middleware = driverManger.getMiddleware(name);
        let driver = (code, options, logH, processH) => {
            return new Promise((res, rej) => {
                let context = {
                    code,
                    options
                };
                middleware(context).then(r => res(r.code), rej);
            });
        };
        return driver;
    }
};
